module.exports = __webpack_public_path__ + "img/head-mv05.b3d99f39.jpg";